import { Component, OnDestroy, ViewEncapsulation } from "@angular/core";
import { Route, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AuthService } from "../../services/auth.service";
import { RoutesService } from "../../services/routes.service";

import { IKeyContact } from "../../interfaces/ikeycontact";
import { IBusinessFunction } from "../../interfaces/ibusinessfunction";

@Component({
    selector: "footer-menu",
    encapsulation: ViewEncapsulation.None,
    templateUrl: "./footer.component.html",
    standalone: false
})
export class FooterComponent implements OnDestroy {
    private destroy$ = new Subject<void>();
    businessFunctionName: string = "";
    todaysDate!: Date;
    routes: Route[] = new Array();
    homeRouteLink: string = "";
    keyContacts!: IKeyContact[];
    businessFunction!: IBusinessFunction;
    legalInformation: string = "";

    constructor(private routesService: RoutesService, private router: Router, private authService: AuthService) {

    }

    ngOnInit(): void {
        this.buildMenu(AuthService.businessFunction);
        this.authService.businessFunctionAnnounced$
            .pipe(takeUntil(this.destroy$))
            .subscribe(businessFunction => {
                this.buildMenu(businessFunction);
            });
    }

    /**
     * Populate the legal information from the selected business function and
     * inject copy right and current year
     */
    populateLegalInformaton(): void {
        if (this.businessFunction.legalInformation != null) {
            let copyrightYear: string = "<br /> \u00A9 " + new Date().getFullYear().toString() + ". For information, contact Deloitte Touche Tohmatsu Limited";
            this.legalInformation = this.businessFunction.legalInformation + copyrightYear;
        }
    }

    /**
     * Creates the footer for the selected business function.
     * Also listens for changes to the business function.
     */
    buildMenu(businessFunction: IBusinessFunction | null): void {
        if (!AuthService.businessFunctionId || !businessFunction) {
            return;
        }
        this.businessFunction = businessFunction;
        this.businessFunctionName = businessFunction.displayName;
        this.routes = this.routesService.getNavigationRoutes(this.router, AuthService.businessFunction);
        this.routes.forEach((r: Route) => {
            if (r.data && r.path) {
                r.data['nav'].navPath = r.path.replace(":defaultroute", businessFunction!.defaultRoute);
            }
        });
        const homeRoute = this.routes.find((r: Route) => r.data && r.data['nav'].text === "Home");
        this.homeRouteLink = homeRoute?.data?.['nav']?.navPath || "";
        const activeKeyContacts = businessFunction.keyContacts.filter((obj) => {
            return obj.disabled === false;
        });
        this.keyContacts = activeKeyContacts;
        this.todaysDate = new Date();
        this.populateLegalInformaton();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
